import { Link } from 'react-router'
import { Plug } from 'lucide-react'
import { trpc } from '@/config/trpc'
import env from '@/config/env'

/**
 * One quiet line on the home page: connect an agent, or confirm one is already
 * connected. Deliberately small — it's a signpost for people who don't know the
 * MCP server exists, not a feature pitch. Renders nothing while loading so it
 * never causes a layout jump under the composer.
 */
export function McpStatusHint() {
  const { data: connections, isLoading } = trpc.mcpToken.list.useQuery()

  if (isLoading || !connections) return null

  if (connections.length === 0) {
    return (
      <p className="text-muted-foreground mt-8 text-center text-xs">
        <Plug className="mr-1.5 inline size-3.5 align-[-2px]" />
        Work on this brand from Claude or ChatGPT.{' '}
        <Link to="/account/mcp" className="text-foreground underline underline-offset-2">
          Connect an agent
        </Link>
      </p>
    )
  }

  // More than one is common (a client per brand, or Desktop plus Code), so name
  // the client only when there's exactly one thing to name.
  const label =
    connections.length === 1
      ? `${connections[0]!.clientName} is connected`
      : `${connections.length} agents connected`

  return (
    <p className="text-muted-foreground mt-8 text-center text-xs">
      <span className="mr-1.5 inline-block size-1.5 rounded-full bg-emerald-500 align-middle" />
      {label}.{' '}
      <Link to="/account/mcp" className="text-foreground underline underline-offset-2">
        Manage
      </Link>
      {' · '}
      <a
        href={`${env.VITE_API_URL}/docs`}
        target="_blank"
        rel="noreferrer"
        className="text-foreground underline underline-offset-2">
        API docs
      </a>
    </p>
  )
}
